import type { HTMLProps } from 'react';
import React from 'react';
import cx from 'classnames';

import styles from './DatagridBody.module.scss';

export type DatagridBodyProps = HTMLProps<HTMLDivElement>;

export const DatagridBody = React.forwardRef<HTMLDivElement, DatagridBodyProps>(
	({ children, className, ...props }, ref) => (
		<div ref={ref} className={cx(styles.datagridBody, className)} role="rowgroup" {...props}>
			{children}
		</div>
	),
);
